/**
 * Serialize a flat params object into a URL query string.
 *
 * Uses URLSearchParams under the hood — array values are converted to
 * comma-separated strings via `.toString()`, matching the backend's
 * expected format.
 *
 * @param {Object} data  Key-value pairs to serialize
 * @returns {string} Encoded query string (without leading `?`)
 */
export const toUrlParams = (data) => {
  const searchParams = new URLSearchParams()

  Object.keys(data).forEach((key) => searchParams.append(key, data[key]))

  return searchParams.toString()
}

/**
 * Shared Axios config for multipart/form-data requests (podcast/episode file uploads).
 */
export const MULTIPART_HEADERS = { headers: { "Content-Type": "multipart/form-data" } }

/**
 * Build a FormData payload for an episode update/create request.
 * Appends the serialized episode JSON and, if present, a logo file.
 *
 * @param {Object} episode  Episode data object (may include a `logoFile` File).
 * @returns {FormData}
 */
export const buildEpisodeFormData = (episode) => {
  const data = new FormData()
  data.append("episode", JSON.stringify(episode))
  if (episode.logoFile) {
    data.append("logo", episode.logoFile)
  }
  return data
}

